/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import classNames from 'classnames'
import getConfig from 'next/config'
import { memo, useMemo } from 'react'
import CustomImage from 'src/components/Image'
import useI18n from 'src/hooks/use_i18n'
import { AllCarriersInfoDTO } from 'src/types'

const { publicRuntimeConfig } = getConfig()

const assetPrefix = publicRuntimeConfig.assetPrefix || ''

// #region component
interface Props {
  carriersInfoData?: any
  carrier: AllCarriersInfoDTO
  totalCarriersStr: number | string
  carrierName?: string
  configAnswer?: boolean
}

const HAS_LANGUGE_ENUM: string[] = ['de', 'it', 'fr', 'es', 'pt', 'ru', 'zh-cn', 'zh-hk']
const ALIBABACOM_LOGISTICS = 191193

function HowDoITrack({ carrier, totalCarriersStr, carrierName = '17track' }: Props) {
  const { $t, activeLocale: locale, i18nFormatAll } = useI18n()
  const showImgLocale = useMemo(() => {
    return HAS_LANGUGE_ENUM.includes(locale) ? locale : 'en'
  }, [locale])

  const questionText = useMemo(() => {
    let otherText = ''
    // 因为合作关系，当运输商为alibabacom-logistics时，需要加一个超链接
    if (carrier?.key === ALIBABACOM_LOGISTICS && locale === 'en') {
      const alibabacomHref =
        'https://bsscommerce.com/shopify/store-locator/?utm_source=17track&utm_medium=carriers-page-anchortext&utm_content=alibaba-logistics&utm_id=shopify-store-locator-app&utm_campaign=partnership2024'
      otherText = ` In case you are finding a Shopify solution to allow customers to easily and visually locate stores, view nearby options, get directions, enhancing their overall experience, you can choose <a target="_blank" href=${alibabacomHref}>Shopify store locator app</a> from BSS Commerce.`
    }
    return (
      i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem5answer'), {
        carriersName: carrierName
      }) + otherText
    )
  }, [i18nFormatAll])
  return (
    <>
      <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
        <h2
          title={i18nFormatAll(
            $t('ResCarrierListPSeoDetails.global.__pHowDoItrackProblem', {
              carriersName: carrierName
            })
          )}
          itemProp="name"
        >
          {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrackProblem'), {
            carriersName: carrierName
          })}
        </h2>
        <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
          <div itemProp="text">
            <p>
              {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrackAnswer'), {
                carriersName: carrierName
              })}
            </p>
            <h3
              dangerouslySetInnerHTML={{
                __html: i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem1'), {
                  carriersUrl: carrierName,
                  carriersUrlUrl: carrier._url
                })
              }}
            ></h3>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 1
                    })}</strong>
                    ${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem1answer'), {
                      carriersName: carrierName
                    })}`
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                  <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                    '0': 2
                  })}</strong>
                  ${$t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2answer')}`
              }}
            ></p>

            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 3
                    })}</strong>
                    ${$t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem3answer')}`
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 4
                    })}</strong>
                    ${$t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem4answer')}`
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: questionText
              }}
            ></p>
            <h3
              dangerouslySetInnerHTML={{
                __html: i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2'), {
                  carriersName: carrierName,
                  yqTrackUrl: `
                  <a target="_blank" href="https://www.17track.net/${locale}">
                      17TRACK
                    </a>`
                })
              }}
            ></h3>
            <p
              dangerouslySetInnerHTML={{
                __html: i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2desc'), {
                  carriersName: carrierName,
                  carriersNums: totalCarriersStr,
                  uspsUrl: `
                    <a target="_blank" href="https://www.17track.net/${locale}/carriers/usps">
                      USPS
                    </a>
                  `,
                  upsUrl: `
                    <a target="_blank" href="https://www.17track.net/${locale}/carriers/ups">
                      UPS
                    </a>
                  `,
                  fedexUrl: `
                    <a target="_blank" href="https://www.17track.net/${locale}/carriers/fedex">
                      FedEx
                    </a>
                  `,
                  dhlUrl: `
                    <a target="_blank" href="https://www.17track.net/${locale}/carriers/dhl-express">
                      DHL
                    </a>
                  `
                })
              }}
            ></p>
            {locale === 'en' ? (
              <p>
                <strong>
                  Step 1: Visit the{' '}
                  <a target="_blank" href="https://www.17track.net/en/tracking">
                    17TRACK tracking page
                  </a>
                  .
                </strong>
              </p>
            ) : (
              <p
                dangerouslySetInnerHTML={{
                  __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 1
                    })}</strong>
                    ${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2answer1'), {
                      yqTrackUrl: '17TRACK',
                      yqTrackUrlUrl: 'https://www.17track.net/' + locale
                    })}`
                }}
              ></p>
            )}

            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 2
                    })}</strong>
                    ${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2answer2'), {
                      carriersName: carrierName
                    })}`
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 3
                    })}</strong>
                    ${$t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2answer3')}`
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pStepText'), {
                      '0': 4
                    })}</strong>
                    ${$t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2answer4')}`
              }}
            ></p>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                    <strong>${$t('ResCarrierListPSeoDetails.global.__pNoteText')}</strong>
                    ${$t('ResCarrierListPSeoDetails.global.__pHowDoItrack_problem2answer5')}`
              }}
            ></p>
            <div className="relative">
              <CustomImage
                src={`${assetPrefix}/assets/images/carriers/carrier_info/common/${
                  locale === 'en' ? 'tracking_17track' : `track_17track_${showImgLocale}`
                }`}
                errorSrc={assetPrefix + '/assets/images/carriers/carrier_info/common/track_17track_en'}
                loading="lazy"
                decoding="async"
                alt={
                  locale === 'en'
                    ? "Easily track your packages with 17TRACK tracking page. Enter your tracking number to get real-time updates on your package's location and status."
                    : i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pImgDesc'), {
                        carriersName: carrierName
                      })
                }
                fill
                className={classNames('w-100 lazy-image-fill')}
              />
            </div>
            <p>
              <strong>{$t('ResCarrierListPSeoDetails.global.__pImgOptionalText')}</strong>
            </p>
            <p>
              <strong>• {$t('ResCarrierListPSeoDetails.global.__pImgType1')}</strong>
              {$t('ResCarrierListPSeoDetails.global.__pImgType1Answer')}
            </p>
            <p>
              <strong>• {$t('ResCarrierListPSeoDetails.global.__pImgType2')}</strong>
              {$t('ResCarrierListPSeoDetails.global.__pImgType2Answer')}
            </p>
            <p>
              <strong>{$t('ResCarrierListPSeoDetails.global.__pImgType3')}</strong>
            </p>
            <p
              dangerouslySetInnerHTML={{
                __html: `
                      ${i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pImgType3Answer'), {
                        mobileAppUrl: $t('ResCarrierListPSeoDetails.global.__pMobileAppText'),
                        mobileAppUrlUrl: 'https://www.17track.net/' + locale + '/app'
                      })}
                      `
              }}
            ></p>
            {[190283, 191159].includes(carrier?.key) && locale == 'en' && (
              <p>
                To learn more about tracking your CJ packages efficiently, check out{' '}
                <a
                  target="_blank"
                  href="https://blog.cjdropshipping.com/detail/How-to-Track-Your-CJ-Packages-in-2024--A-Step-by-Step-Guide-for-Efficient-Tracking"
                >
                  {`CJ Dropshipping's comprehensive guide`}
                </a>
                .
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(HowDoITrack)
